import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ImageLoader from '../../../../components/ImageLoader';
import { getListMenu } from '../../../../store/reducers/ufood-x/menu';
import { LoaderIcon } from "../../../../utils/svg";
import useNavigation from '../../../../hook/useNavigation';

const ListMenu = () => {
	const dispatch = useDispatch();
	const navigate = useNavigation();
	const scrollRef = useRef(null);

	const company = useSelector((store) => store?.company);
	const { data: menus = [], loading, page, totalPages } = useSelector((state) => state.menu);
	useEffect(() => {
		if (!company?.companyID) return;
		dispatch(getListMenu({ page: 1, limit: 3, companyID: company?.companyID }));
	}, [company?.companyID]);

	const handleScroll = () => {
		const el = scrollRef.current;
		if (!el || loading) return;

		const isEnd =
			el.scrollLeft + el.clientWidth >= el.scrollWidth - 20;

		if (isEnd && page < totalPages) {
			dispatch(
				getListMenu({
					page: page + 1,
					limit: 3,
					companyID: company?.companyID
				})
			);
		}
	};

	const handleDetail = (cmspageId) => {
		navigate.push(`/ufood-x/menu-detail/${cmspageId}`);
	}

	return (
		<div className="mb-4">
			<div className='mb-4 text-base font-semibold text-gray-700'>
				List Menu
			</div>

			<div
				ref={scrollRef}
				onScroll={handleScroll}
				className='flex gap-2 overflow-x-auto scroll-smooth'
			>
				{menus?.map((menu, index) => (
					<div
						key={index}
						className='relative w-1/3 aspect-[4/3] overflow-hidden rounded-lg'
						onClick={()=> handleDetail(menu?.cmspageId)}
					>
						<ImageLoader
							alt={menu?.cmspageBannerImage}
							src={menu?.cmspageBannerImage}
							className='h-full w-full object-cover'
						/>
						<div className='absolute inset-0 bg-gradient-to-t from-black/50 via-black/0 to-transparent pointer-events-none' />
						<div className='absolute bottom-2 left-2 right-2 text-xxs font-bold text-white'>
							{menu?.cmspageTitle}
						</div>
					</div>
				))}

				{loading && (
					<div className="flex items-center justify-center min-w-[100px]">
						<LoaderIcon />
					</div>
				)}
			</div>
		</div>
	);
};

export default ListMenu;
